import { AccountComponent } from './containers/account.component';

import { DynamicRoute } from '../shared/navigation/dynamic-route';
import { NeverShowRouteResolver } from '../shared/navigation/never-show-route-resolver';
import { PermissionLevel } from '../shared/permission/permission';
import { RouteType } from '../shared/navigation/route-type.enum';
import { VersionGuard } from '../shared/guards/version-guard';
import { PermissionGuard } from '../shared/guards/permission-guard';

export const accountRoutes: Array<DynamicRoute> = [
  {
    path: 'account',
    component: AccountComponent,
    canActivate: [VersionGuard, PermissionGuard],
    data: {
      show: NeverShowRouteResolver,
      title: 'Account',
      permissionLevel: PermissionLevel.MANAGER,
      type: [RouteType.NORMAL]
    }
  }
];
